/* Teabo — révélations au scroll (une fois, stagger par groupe). Reduced-motion safe. */
(function () {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var SEL = '.teabo-pcard, .teabo-avis__col, .teabo-qcard, .teabo-pvu__item, .teabo-acard, .teabo-faq details, .teabo-diag, .teabo-cof__stage';
  function init() {
    var targets = Array.prototype.slice.call(document.querySelectorAll(SEL));
    targets.forEach(function (el) {
      if (el.classList.contains('teabo-diag')) return;
      el.classList.add('teabo-rv');
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) { return c.classList && c.classList.contains('teabo-rv'); });
      var i = sibs.indexOf(el);
      if (i > 0) el.style.setProperty('--rv-delay', Math.min(i, 6) * 70 + 'ms');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('teabo-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
